const getters = {
  getDuplicates: state => state.duplicates,
  getDuplicate: state => state.duplicate,
  getDuplicateIdsToResolve: state => state.duplicateIdsToResolve.duplicates,
  getDuplicateMain: state => state.duplicateIdsToResolve.main,
  getDuplicatesToResolve: state => state.duplicatesToResolve,
  getIsDuplicateLoading: state => state.isDuplicateLoading,
  getDuplicateError: state => state.duplicateError,
};

export default getters;
